<!--suppress HtmlFormInputWithoutLabel -->
<div [class]="controlWrapperClass()">
  <ng-template #formControl>
    <input
      *ngIf="type !== 'select'"
      [id]="field"
      [name]="field"
      [type]="type"
      [formControlName]="field"
      class="form-control"
      [ngClass]="resolvedInputNGClass"
      [autocomplete]="autocomplete !== undefined ? autocomplete : false"
      (focus)="onInputFocus()"
      [placeholder]="placeholder !== undefined ? placeholder : false"
      [readonly]="readonly !== undefined && readonly !== false"
    />
    <select
      *ngIf="type === 'select'"
      [id]="field"
      [name]="field"
      [formControlName]="field"
      class="form-control with-placeholder-label"
      [ngClass]="resolvedInputNGClass"
      (focus)="onInputFocus()"
    >
      <option *ngFor="let itm of selectOptions" [value]="itm.value">{{itm.label}}</option>
    </select>
  </ng-template>
  <div class="input-group" *ngIf="prepend || append">
    <div class="input-group-prepend" *ngIf="prepend">
      <ng-container [ngTemplateOutlet]="prepend"></ng-container>
    </div>
    <ng-container [ngTemplateOutlet]="formControl"></ng-container>
    <div class="input-group-append" *ngIf="append">
      <ng-container [ngTemplateOutlet]="append"></ng-container>
    </div>
  </div>
  <ng-container *ngIf="!prepend && !append" [ngTemplateOutlet]="formControl"></ng-container>
  <ng-content></ng-content>
  <label
    [for]="field"
    [class]="labelClass()"
  >{{label}}</label>
</div>
